export const FETCH_SITES = 'FETCH_SITES';
export const UPDATE_ACTIVE_SORT_FIELD_SITES = 'UPDATE_ACTIVE_SORT_FIELD_SITES';
export const UPDATE_SEARCH_SITES = 'UPDATE_SEARCH_SITES';
export const CLEAR_SEARCH_SITES = 'CLEAR_SEARCH_SITES';
export const TOGGLE_NOT_LINKED_FILTER = 'TOGGLE_NOT_LINKED_FILTER';
